import * as React from "react";
import { sendRequest } from "../../helpers/ajax";
import IListResults from "../../types/IListResults";
import IResponse from "../../types/IResponse";
import IUserSearchRequest from "../../types/IUserSearchRequest";
import IUserSearchResult from "../../types/IUserSearchResult";
import UserList from "./UserList";

interface IUserListState {
    loading: boolean;
}

class UserListContainer extends React.Component<{}, IUserListState> {

    constructor(props: {}) {
        super(props);

        this.state = {
            loading: false
        };

        this.searchUsers = this.searchUsers.bind(this);
    }

    public render() {
        return (
            <UserList
                loading={this.state.loading}
                searchUsers={this.searchUsers}
            />
        );
    }

    private async searchUsers(criteria: IUserSearchRequest): Promise<IResponse<IListResults<IUserSearchResult>> | null> {
        this.setState({ loading: true });

        const result = await sendRequest<IResponse<IListResults<IUserSearchResult>>>("/api/users/search", "POST", criteria);

        this.setState({ loading: false });

        return result;
    }
}

export default UserListContainer;



// WEBPACK FOOTER //
// ./src/components/UserList/UserListContainer.tsx